import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GlfocusDirective } from './directives/glfocus.directive';
import { SkeletorValueAccessor } from './directives/skeletor-value-accessor.directive';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatStepperModule } from '@angular/material/stepper';
import { TranslateModule } from '@ngx-translate/core';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha-2';
// components
import {
  CmsContentComponent,
  DynamicFormComponent,
  DynamicFormQuestionComponent,
  DynamicFormErrorComponent,
  NotFoundComponent,
  PasswordStrengthBarComponent,
  PreloaderComponent,
  SelectDropdownComponent,
  QuestionControlService
} from './components';
import { FooterComponent } from './components/footer/footer.component';
// services
import {
  ClientRegisterService,
  CountriesService,
  EmbedLoginService,
  EmitterService,
  ErrorHandlerService,
  JwtService,
  LocalesService,
  MicrofrontendsService,
  RemoteLoggingService,
  StoreService,
  ThemeService,
  ToastService,
  UiService,
  UtilsService,
  ContentfulService
} from './services';
import { SafeContentPipe } from './pipes/safe-content.pipe';
import { GtmService } from '@core/services/gtm/gtm.service';

const modules = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
  MatFormFieldModule,
  MatSelectModule,
  MatSliderModule,
  MatStepperModule,
  TranslateModule,
  RecaptchaModule,
  RecaptchaFormsModule
];

const components = [
  CmsContentComponent,
  DynamicFormComponent,
  DynamicFormQuestionComponent,
  DynamicFormErrorComponent,
  NotFoundComponent,
  PasswordStrengthBarComponent,
  PreloaderComponent,
  FooterComponent,
  SelectDropdownComponent
];

const services = [
  ClientRegisterService,
  CountriesService,
  EmbedLoginService,
  EmitterService,
  ErrorHandlerService,
  JwtService,
  LocalesService,
  MicrofrontendsService,
  QuestionControlService,
  RemoteLoggingService,
  StoreService,
  ThemeService,
  ToastService,
  UiService,
  UtilsService,
  ContentfulService,
  GtmService
];

const directives = [GlfocusDirective, SkeletorValueAccessor];

@NgModule({
  declarations: [...components, ...directives, SafeContentPipe],
  imports: [...modules],
  exports: [...modules, ...components, ...directives, SafeContentPipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [...services]
    };
  }
}
